import { useTranslation } from 'react-i18next';
import { HiCheckCircle, HiXCircle } from 'react-icons/hi';
import { medirContrasena, LONGITUD_MINIMA } from '../utils/fuerzaContrasena';

/**
 * La barra y la lista de requisitos, mientras se escribe.
 *
 * Sin esto, la única forma de saber qué exige la aplicación era enviar el
 * formulario y que lo rechazara — y con suerte leer el motivo antes de que el
 * aviso desapareciera. Ver qué falta mientras escribes es lo que convierte
 * «contraseña rechazada» en algo sobre lo que puedes actuar.
 *
 * Los colores siguen el estándar del proyecto: rojo lo que está mal, ámbar lo
 * que está a medias, verde lo que ya cumple.
 */
export default function FuerzaContrasena({ contrasena, email = '', nombre = '' }) {
    const { t } = useTranslation();

    if (!contrasena) return null;

    const { nivel, etiqueta, reglas } = medirContrasena(contrasena, { email, nombre });

    const colores = ['bg-slate-200', 'bg-red-500', 'bg-amber-500', 'bg-lime-500', 'bg-green-500'];
    const textos = ['', 'text-red-500', 'text-amber-500', 'text-lime-600', 'text-green-600'];

    const lista = [
        { clave: 'longitud', ok: reglas.longitud, texto: t('password_strength.rule_length', { n: LONGITUD_MINIMA }) },
        { clave: 'noConocida', ok: reglas.noConocida, texto: t('password_strength.rule_known') },
        { clave: 'noPersonal', ok: reglas.noPersonal, texto: t('password_strength.rule_personal') },
        { clave: 'noTrivial', ok: reglas.noTrivial, texto: t('password_strength.rule_trivial') }
    ];

    return (
        <div className="mt-2 space-y-2">
            <div className="flex items-center gap-2">
                <div className="flex-1 flex gap-1">
                    {[1, 2, 3, 4].map((n) => (
                        <div
                            key={n}
                            className={`h-1.5 flex-1 rounded-full transition-colors ${
                                n <= nivel ? colores[nivel] : 'bg-slate-200 dark:bg-slate-700'
                            }`}
                        />
                    ))}
                </div>
                <span className={`text-xs font-medium ${textos[nivel]}`}>{t(etiqueta)}</span>
            </div>

            <ul className="space-y-1">
                {lista.map((r) => (
                    <li key={r.clave} className="flex items-start gap-1.5 text-xs">
                        {r.ok
                            ? <HiCheckCircle className="w-3.5 h-3.5 text-green-500 shrink-0 mt-px" />
                            : <HiXCircle className="w-3.5 h-3.5 text-slate-300 dark:text-slate-600 shrink-0 mt-px" />}
                        <span className={r.ok ? 'text-green-600 dark:text-green-400' : 'text-slate-500 dark:text-slate-400'}>
                            {r.texto}
                        </span>
                    </li>
                ))}
            </ul>
        </div>
    );
}
